import useResponsive from "helpers/useResponsive";
import { motion } from "framer-motion";

import { ReactComponent as RegisterIcon } from "../../../assets/images/register.svg";
import { ReactComponent as RiskIcon } from "../../../assets/images/risk.svg";
import { ReactComponent as WinIcon } from "../../../assets/images/win.svg";
import { ReactComponent as LineDots } from "../../../assets/images/line-dots.svg";

// If you re-enable the testimonial images later, you can uncomment these:
// import image7 from "assets/images/7.png";
// import image8 from "assets/images/8.png";

export default function Product() {
  const { isMobile } = useResponsive();

  return (
    <section
      id="product"
      className="grid md:gap-[5rem] gap-12 justify-items-center md:mt-[11.25rem] my-[5rem] px-4"
    >
      <h3 className="title uppercase md:text-[3rem] text-[2.25rem] font-[500] text-center">
        How It Works
      </h3>

      <div className="md:flex lg:gap-[5rem] md:gap-8 gap-8 relative grid">
        {!isMobile && (
          <motion.div
            className="absolute z-[1] top-[2rem] w-full overflow-hidden"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.75 }}
            viewport={{ once: true }}
          >
            <LineDots className="w-full" />
          </motion.div>
        )}

        <Card
          title="Register"
          description="Sign up, and you’ll begin receiving daily notifications. Each day, you’ll get either the qualified prediction(s) selected by the algorithm or a notification that no prediction qualified."
          delay={0}
        />
        <Card
          title="Place Your Wager"
          description="Once you receive the prediction, it's up to you to place your wager on the platform of your choice."
          delay={0.25}
        />
        <Card
          title="Enjoy the Game"
          description="Place your wager, sit back, and watch knowing you’re backed by the highest data-driven win probabilities—not emotion or guesswork."
          delay={0.5}
        />
      </div>

      {/*
      <div className="flex flex-col md:flex-row justify-center items-center gap-6 mt-8">
        <motion.img
          src={image7}
          alt="Testimonial"
          className="w-[500px] h-auto"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        />
        <motion.img
          src={image8}
          alt="Testimonial"
          className="w-[500px] h-auto"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        />
      </div>
      */}
    </section>
  );
}

function Card({
  title,
  description,
  delay,
}: {
  title?: string;
  description?: string;
  delay: number;
}) {
  return (
    <motion.div
      className="grid text-center content-baseline"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true }}
    >
      {title === "Register" && (
        <RegisterIcon className="w-[6.25rem] h-[6.25rem] mx-auto z-[2]" />
      )}
      {title === "Place Your Wager" && (
        <RiskIcon className="w-[6.25rem] h-[6.25rem] mx-auto z-[2]" />
      )}
      {title === "Enjoy the Game" && (
        <WinIcon className="w-[6.25rem] h-[6.25rem] mx-auto z-[2]" />
      )}

      <span className="font-sans text-[1.75rem] font-[700] tracking-[-0.54px] md:mt-[3rem] mt-4">
        {title}
      </span>
      <p className="font-sans font-[400] max-w-[320px] mt-[0.625rem]">
        {description}
      </p>
    </motion.div>
  );
}
